import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { HomeService, Production } from './home.service';

@Component({
  selector: 'digitalization-tool-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  public   productionData: Production[];
  public popupOpened = false;


  constructor(
    public dataService: DataService,
    public homeService: HomeService
  ) {
    this.productionData = homeService.getProductionData();
   }

  ngOnInit(): void { }

  public openAddAuditDialog(): void {
    this.popupOpened = true;
  }
}
